import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import {
  FiCheck, FiX, FiEye, FiUserPlus, FiLoader, FiShield, FiUserCheck,
  FiHash, FiUsers, FiAlertCircle, FiClock, FiAward, FiTrendingUp,
  FiActivity, FiGlobe, FiCpu, FiDatabase, FiShieldOff, FiArrowLeft,
  FiArrowRight, FiCamera, FiUpload, FiFileText, FiMapPin, FiMail,
  FiPhone, FiCalendar, FiFlag, FiHome, FiBriefcase, FiHeart,
  FiUser, FiLock, FiPhoneCall, FiMap, FiBookOpen, FiCreditCard,
  FiDollarSign, FiInfo
} from 'react-icons/fi';
import './KYCVerification.css';

// Types
interface KYCUser {
  uuid: string;
  user_id?: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  created_at: string;
  status: string;
  submitted_documents?: any;
}

// Register User Form Data - Full User Schema
interface RegisterFormData {
  // Required
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  password: string;
  
  // Personal
  date_of_birth: string;
  place_of_birth: string;
  nationality: string;
  marital_status: string;
  employment_status: string;
  number_of_children: number;
  sex: string;
  
  // Address
  address: string;
  postal_address: string;
  
  // Document Numbers
  passport_number: string;
  birth_certificate: string;
  driver_license: string;
  
  // Image URLs
  image: string;
  passport_image: string;
  birth_certificate_image: string;
  drivers_license_image: string;
  national_id_image: string;
  
  // Social
  username: string;
  display_name: string;
  bio: string;
}

// Liberia Counties
const LIBERIA_COUNTIES = [
  "Bomi", "Bong", "Gbarpolu", "Grand Bassa", "Grand Cape Mount",
  "Grand Gedeh", "Grand Kru", "Lofa", "Margibi", "Maryland",
  "Montserrado", "Nimba", "Rivercess", "River Gee", "Sinoe",
];

// Postal codes data
const POSTAL_CODES: Record<string, Array<{ code: string; area: string }>> = {
  "Montserrado": [
    {"code": "10101", "area": "BENTOL - BENSONVILLE - DISTRICT 1"},
    {"code": "10102", "area": "CAREYSBURG - CAREYSBURG - DISTRICT 1"},
    {"code": "10103", "area": "TODEE - TODEE - DISTRICT 1"},
    {"code": "10104", "area": "LOUISIANA - LOUISIANA - DISTRICT 1"},
    {"code": "10201", "area": "JOHNSONVILLE - JOHNSONVILLE - DISTRICT 2"},
    {"code": "10202", "area": "DOUBLE BRIDGE - SOMALIA DRIVE - DISTRICT 2"},
    {"code": "10203", "area": "JACOB TOWN - SOMALIA DRIVE - DISTRICT 2"},
    {"code": "10204", "area": "ZINC FACTORY - SOMALIA DRIVE - DISTRICT 2"},
    {"code": "10205", "area": "MOUNT BARCLAY - MOUNT BARCLAY - DISTRICT 2"},
    {"code": "10301", "area": "PIPELINE - PAYNESVILLE - DISTRICT 3"},
    {"code": "10302", "area": "MORRIS FARM - PAYNESVILLE - DISTRICT 3"},
    {"code": "10303", "area": "WOOD CAMP - PAYNESVILLE - DISTRICT 3"},
    {"code": "10304", "area": "NEEZOE - PAYNESVILLE - DISTRICT 3"},
    {"code": "10401", "area": "BARNARD FARM - PAYNESVILLE - DISTRICT 4"},
    {"code": "10402", "area": "OMEGA/KEMAH TOWN - PAYNESVILLE - DISTRICT 4"},
    {"code": "10403", "area": "PAYESVILLE JOE BAR - PAYNESVILLE - DISTRICT 4"},
    {"code": "10404", "area": "DUPORT ROAD - PAYNESVILLE - DISTRICT 4"},
    {"code": "10501", "area": "RED LIGHT - PAYNESVILLE - DISTRICT 5"},
    {"code": "10502", "area": "POLICE ACADEMY - PAYNESVILLE - DISTRICT 5"},
    {"code": "10503", "area": "BASSA TOWN - PAYNESVILLE - DISTRICT 5"},
    {"code": "10504", "area": "72ND - PAYNESVILLE - DISTRICT 5"},
    {"code": "10505", "area": "TOWN HALL - PAYNESVILLE - DISTRICT 5"},
    {"code": "10506", "area": "A.B TOLBERT ROAD - PAYNESVILLE - DISTRICT 5"},
    {"code": "10507", "area": "PAGOS ISLAND - PAYNESVILLE - DISTRICT 5"},
    {"code": "10508", "area": "SWANKAMORE - PAYNESVILLE - DISTRICT 5"},
    {"code": "10601", "area": "GSA ROAD ROCKVILLE - PAYNESVILLE - DISTRICT 6"},
    {"code": "10602", "area": "S.D COOPER ROAD - PAYNESVILLE - DISTRICT 6"},
    {"code": "10603", "area": "KPELLE TOWN - PAYNESVILLE - DISTRICT 6"},
    {"code": "10604", "area": "KING GRAY - PAYNESVILLE - DISTRICT 6"},
    {"code": "10605", "area": "ELWA - PAYNESVILLE - DISTRICT 6"},
    {"code": "10606", "area": "REHAB/BORBOR TOWN - PAYNESVILLE - DISTRICT 6"},
    {"code": "10607", "area": "KENDE-JAH - PAYNESVILLE - DISTRICT 6"},
    {"code": "10608", "area": "THINKER'S VILLAGE - PAYNESVILLE - DISTRICT 6"},
    {"code": "10609", "area": "BAPTIST SEMINARY - ROBERT'S FIELD HIGH WAY - DISTRICT 6"},
    {"code": "10610", "area": "WAMBA TOWN - ROBERT'S FIELD HIGH WAY - DISTRICT 6"},
    {"code": "10701", "area": "WEST POINT - WEST POINT TOWNSHIP - DISTRICT 7"},
    {"code": "10702", "area": "ROCK CRUSHER - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10703", "area": "SNAPPER HILL - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10704", "area": "MAMBA POINT - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10705", "area": "U. N. DRIVE - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10706", "area": "RANDALL/NEWPORT/LYNCH STREET - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10707", "area": "CAREY/GURLEY/MECHLIN STREET - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10708", "area": "BROAD/ASHMUN STREET - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10709", "area": "BENSON/WARREN/PERRY/CLAY/JOHNSON STREET - CENTRAL MONROVIA - DISTRICT 7"},
    {"code": "10801", "area": "CROWN HILL - MONROVIA - DISTRICT 8"},
    {"code": "10802", "area": "SLIP WAY - MONROVIA - DISTRICT 8"},
    {"code": "10803", "area": "SONIWEIN - MONROVIA - DISTRICT 8"},
    {"code": "10804", "area": "BUZZI QUARTERS - MONROVIA - DISTRICT 8"},
    {"code": "10805", "area": "JALLAH TOWN - MONROVIA - DISTRICT 8"},
    {"code": "10806", "area": "CAPITAL HILL - MONROVIA - DISTRICT 8"},
    {"code": "10807", "area": "SINKOR (1ST - 12) STREET - MONROVIA - DISTRICT 8"},
    {"code": "10901", "area": "SINKOR (13 - 24) STREET - MONROVIA - DISTRICT 9"},
    {"code": "10902", "area": "NEW MATADI - MONROVIA - DISTRICT 9"},
    {"code": "10903", "area": "OLD MATADI - MONROVIA - DISTRICT 9"},
    {"code": "10904", "area": "LAKPAZEE - MONROVIA - DISTRICT 9"},
    {"code": "10905", "area": "FIAMA - MONROVIA - DISTRICT 9"},
    {"code": "10906", "area": "RAYMOND FIELD - MONROVIA - DISTRICT 9"},
    {"code": "10907", "area": "GBANGAYE TOWN - MONROVIA - DISTRICT 9"},
    {"code": "10908", "area": "AIRFIELD - MONROVIA - DISTRICT 9"},
    {"code": "10909", "area": "WROTO TOWN - MONROVIA - DISTRICT 9"},
    {"code": "10910", "area": "FISH MARKET - MONROVIA - DISTRICT 9"},
    {"code": "11001", "area": "KEY & DEATH HOLE - OLD ROAD - DISTRICT 10"},
    {"code": "11002", "area": "CATHOLIC HOSPITAL - OLD ROAD - DISTRICT 10"},
    {"code": "11003", "area": "DIVINE & TOGBA CAMP - OLD ROAD - DISTRICT 10"},
    {"code": "11004", "area": "NIPPAY TOWN - OLD ROAD - DISTRICT 10"},
    {"code": "11005", "area": "SMYTHE ROAD - OLD ROAD - DISTRICT 10"},
    {"code": "11006", "area": "CHUGBOR - OLD ROAD - DISTRICT 10"},
    {"code": "11007", "area": "GAYE TOWN COMMUNITY - OLD ROAD - DISTRICT 10"},
    {"code": "11008", "area": "TARR TOWN - OLD ROAD - DISTRICT 10"},
    {"code": "11009", "area": "YEKPEE TOWN - OLD ROAD - DISTRICT 10"},
    {"code": "11010", "area": "PEACE ISLAND - CONGO TOWN - DISTRICT 10"},
    {"code": "11011", "area": "CONGO TOWN - CONGO TOWN - DISTRICT 10"},
    {"code": "11101", "area": "CASSAVA HILL - CALDWELL TOWNSHIP - DISTRICT 11"},
    {"code": "11102", "area": "SAMUKAI TOWN - CALDWELL TOWNSHIP - DISTRICT 11"},
    {"code": "11103", "area": "DIXVILLE - DIXVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11104", "area": "CALDWELL - CALDWELL TOWNSHIP - DISTRICT 11"},
    {"code": "11105", "area": "KABA TOWN - BARDNERSVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11106", "area": "BEHWEIN COMMUNITY - BARDNERSVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11107", "area": "BARNESVILLE ESTATE - BARDNERSVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11108", "area": "GRASS FIELD - BARDNERSVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11109", "area": "DAY BREAK MOUTH OPEN - BARDNERSVILLE TOWNSHIP - DISTRICT 11"},
    {"code": "11201", "area": "JOHNSONVILLE ROAD - BARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11202", "area": "CHICKEN SOUP FACTORY - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11203", "area": "SHOE FACTORY - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11204", "area": "MTA - GARDNERSVILLE TOWNSHIP -DISTRICT 12"},
    {"code": "11205", "area": "STEPHEN TOLBERT ESTATE - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11206", "area": "RIVER VIEW - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11207", "area": "KESSELLY BOULEVARD - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11208", "area": "MANGROVE ISLAND - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11209", "area": "J.J.Y. SNOW HILL - GARDNERSVILLE TOWNSHIP - DISTRICT 12"},
    {"code": "11301", "area": "NEW GEORGIA - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11302", "area": "ST. MICHEAL - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11303", "area": "CHOCOLATE CITY - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11304", "area": "IRON FACTORY - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11305", "area": "SOS TRANSIT - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11306", "area": "NEW GEORGIA ESTATE - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11307", "area": "BASSA TOWN - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11308", "area": "TOPOE VILLAGE - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11309", "area": "BATTERY FACTORY - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11310", "area": "FLAHN TOWN - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11311", "area": "STOCKTON CREEK - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11312", "area": "JAMAICA ROAD - NEW GEORGIA TOWNSHIP - DISTRICT 13"},
    {"code": "11401", "area": "FREE PORT COMMUNITY - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11402", "area": "COW FACTORY - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11403", "area": "STRUGGLE COMMUNITY - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11404", "area": "HOPE COMMUNITY - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11405", "area": "PEUGEOT GARAGE - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11406", "area": "PAITY TOWN - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11407", "area": "RIVER VIEW - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11408", "area": "CLARA TOWN - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11409", "area": "GIBLATA - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11410", "area": "VIA TOWN - GARGLORH TOWNSHIP - DISTRICT 14"},
    {"code": "11501", "area": "LOGAN TOWN - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11502", "area": "GBANDI TOWN - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11503", "area": "ZINC CAMP - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11504", "area": "ZONDO TOWN - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11505", "area": "BLAMO TOWN - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11506", "area": "KING PETER TOWN - GARGLORH TOWNSHIP - DISTRICT 15"},
    {"code": "11601", "area": "ST. PAUL BRIDGE - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11602", "area": "TWEH FARM - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11603", "area": "MONBOE TOWN - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11604", "area": "LAGON - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11605", "area": "NEW KRU TOWN - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11606", "area": "FUNDAYE - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11607", "area": "DUALA MARKET - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11608", "area": "NYUANTOWN - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11609", "area": "BONG MINES BRIDGE - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11610", "area": "POPO BEACH - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11611", "area": "POINT FOUR (4) - BOROUGH OF KRU TOWN - DISTRICT 16"},
    {"code": "11701", "area": "GBARVEAH - ARTHINGTON - DISTRICT 17"},
    {"code": "11702", "area": "BONOWAH - ARTHINGTON - DISTRICT 17"},
    {"code": "11703", "area": "DINEEKON - ARTHINGTON - DISTRICT 17"},
    {"code": "11704", "area": "CENTRAL ARTHINGTON - ARTHINGTON - DISTRICT 17"},
    {"code": "11705", "area": "MILLSBURG - ARTHINGTON - DISTRICT 17"},
    {"code": "11706", "area": "LUNEH - CLAY ASHLAND - DISTRICT 17"},
    {"code": "11707", "area": "BARCON - CLAY ASHLAND - DISTRICT 17"},
    {"code": "11708", "area": "KAIKPU - CLAY ASHLAND - DISTRICT 17"},
    {"code": "11709", "area": "VIRGINIA - VIRGINIA TOWNSHIP - DISTRICT 17"},
    {"code": "11710", "area": "SUNDUFU - CHEESEMANBURG TOWNSHIP - DISTRICT 17"},
    {"code": "11711", "area": "CHEESEMANBURG - CHEESEMANBURG TOWNSHIP - DISTRICT 17"},
    {"code": "11712", "area": "BREWERVILLE - BREWERVILLE - DISTRICT 17"},
    {"code": "11713", "area": "ROYESVILLE - ROYESVILLE TOWNSHIP - DISTRICT 17"},
    {"code": "11714", "area": "ACROSS THE CREEK - ROYESVILLE TOWNSHIP - DISTRICT 17"},
  ],
  "Bong": [
    {"code": "30101", "area": "DOE - DOE - KOKOYAH"},
    {"code": "30102", "area": "NANGBO - NANGBO - KOKOYAH"},
    {"code": "30103", "area": "TIKPAH - TIKPAH - TUKPAHBLEE"},
    {"code": "30104", "area": "MELEKEI - MELEKEI - TUKPAHBLEE"},
    {"code": "30105", "area": "DEAN TOWN - DEAN - BEINSEN"},
    {"code": "30106", "area": "U-LA - U-LA - BEINSEN"},
    {"code": "30107", "area": "BEHWEE - BEHWEE - BEINSEN"},
    {"code": "30108", "area": "DUTA - DUTA - KPAAI"},
    {"code": "30109", "area": "WOLATA - WOLATA - KPAAI"},
    {"code": "30201", "area": "TAMAY TA - TAMAY TA - JORQUELLEH 2"},
    {"code": "30202", "area": "GBENEQUELLEH - GBENEQUELLEH - JORQUELLEH 2"},
    {"code": "30203", "area": "JANKPAYAH - JANKPAYAH - JORQUELLEH 2"},
    {"code": "30204", "area": "SAMAY - SAMAY - JORQUELLEH 2"},
    {"code": "30205", "area": "MANO-WEASUE - MANOWEASUE - JORQUELLLEH 2"},
    {"code": "30206", "area": "JANYEA - JANYEA - JORQUELLEH 2"},
    {"code": "30207", "area": "KOLLIETA-MULA - KOLLIETA-MULA - JORQUELLEH 2"},
    {"code": "30301", "area": "MELEKEI - GBARNGA - JORQUELLEH 1"},
    {"code": "30302", "area": "CAMP TUBMAN BARRACK - GBARNGA - JORQUELLEH 1"},
    {"code": "30303", "area": "RUBBER FACTORY - GBARNGA - JORQUELLEH 1"},
    {"code": "30304", "area": "LOFA ROAD - GBARNGA - JORQUELLEH 1"},
    {"code": "30305", "area": "IRON GATE - GBARNGA - JORQUELLEH 1"},
    {"code": "30306", "area": "OLD IRON GATE - GBARNGA - JORQUELLEH 1"},
    {"code": "30307", "area": "BROOKLYN - GBARNGA - JORQUELLEH 1"},
    {"code": "30308", "area": "SUGAR HILL - GBARNGA - JORQUELLEH 1"},
    {"code": "30309", "area": "FAR EAST - GBARNGA - JORQUELLEH 1"},
    {"code": "30310", "area": "BROAD STREET - GBARNGA - JORQUELLEH 1"},
    {"code": "30311", "area": "LELEKPAYEA - GBARNGA - JORQUELLEH 1"},
    {"code": "30312", "area": "LPMC ROAD - GBARNGA - JORQUELLLEH 1"},
    {"code": "30313", "area": "GANTA PARKING - GBARNGA - JORQUELLEH 1"},
    {"code": "30314", "area": "COUNTY FIELD - GBARNGA - JORQUELLEH 1"},
    {"code": "30315", "area": "WONGBA - WONGBA - JORQUELLEH 1"},
    {"code": "30316", "area": "GBAOTA - GBAOTA - JORQUELLEH 1"},
    {"code": "30317", "area": "KPANYAH - KPANYAH - JORQUELLEH 1"},
    {"code": "30318", "area": "GBARMUE - GBARMUE - JORQUELLEH 1"},
    {"code": "30401", "area": "MOAGAN - MOAGAN - PANTA"},
    {"code": "30402", "area": "JORWAH - JORWAH - PANTA"},
    {"code": "30403", "area": "BELEFANAI - BELEFANAI - ZOTA"},
    {"code": "30404", "area": "YOWEE - YOWEE - ZOTA"},
    {"code": "30405", "area": "GOU - GOU - SANOYEA"},
    {"code": "30406", "area": "GBONOTA - GBONOTA - SANOYEA"},
    {"code": "30501", "area": "SKT - SKT - SUAKOKO"},
    {"code": "30502", "area": "CUTTINGTON - PHEBE - SUAKOKO"},
    {"code": "30503", "area": "PHEBE - PHEBE - SUAKOKO"},
    {"code": "30504", "area": "SINYEA - SINYEA - SUAKOKO"},
    {"code": "30505", "area": "GEAMUE - GEAMUE - SUAKOKO"},
    {"code": "30506", "area": "DULIMUE - DULIMUE - SUAKOKO"},
    {"code": "30507", "area": "GOKAI - GOKAI - SUAKOKO"},
    {"code": "30601", "area": "GBARTALA - GBARTALA - YEALLLEQUELLEH"},
    {"code": "30602", "area": "PALALA - PALALA - YEALLEQUELLEH"},
    {"code": "30603", "area": "FENUTOLI - FENUTOLI - YEALLEQUELLEH"},
    {"code": "30604", "area": "GARYEA - GARYEA - YEALLEQUELLEH"},
    {"code": "30605", "area": "GLENKORMAH - GLENKORMAH - YEALLEQUELLEH"},
    {"code": "30701", "area": "SALALA - SALALA - SALALA"},
    {"code": "30702", "area": "TOTOTA - TOTOTA - SALALA"},
    {"code": "30703", "area": "POPOTA - POPOTA - FUAMAH"},
    {"code": "30704", "area": "DOBLI ISLAND - DOBLI ISLAND - FUAMAH"},
  ],
  "Grand Bassa": [
    {"code": "40101", "area": "LLOYDSVILLE - KPORKON - DISTRICT 1"},
    {"code": "40102", "area": "KPALAWRU - KPORKON - DISTRICT 1"},
    {"code": "40103", "area": "ZEON - ZEON - DISTRICT 1"},
    {"code": "40104", "area": "ZUZOHN - ZUZOHN - DISTRICT 1"},
    {"code": "40105", "area": "EDINA - EDINA - DISTRICT 1"},
    {"code": "40106", "area": "LITTLE BASSA - EDINA - DISTRICT 1"},
    {"code": "40107", "area": "OWENSGROOVE - OWENSGROOVE - DISTRICT 1"},
    {"code": "40201", "area": "GEEHGBAHN - GEEHBAHN - DISTRICT 2"},
    {"code": "40202", "area": "YEABLOE - YEABLOE - DISTRICT 2"},
    {"code": "40203", "area": "ST. JOHN - ST. JOHN - DISTRICT 2"},
    {"code": "40204", "area": "HARTFORD - HARTFORD - DISTRICT 2"},
    {"code": "40301", "area": "BLEEWEIN TOWN - BUCHANAN - DISTRICT 3"},
    {"code": "40302", "area": "SANWIN TOWN - BUCHANAN - DISTRICT 3"},
    {"code": "40303", "area": "BARCONI - BUCHANAN - DISTRICT 3"},
    {"code": "40304", "area": "UPPER BUCHANAN - BUCHANAN - DISTRICT 3"},
    {"code": "40305", "area": "FOUR HOUSES - BUCHANAN - DISTRICT 3"},
    {"code": "40306", "area": "CENTRAL BUCHANAN - BUCHANAN - DISTRICT 3"},
    {"code": "40307", "area": "LOWER BUCHANAN - BUCHANAN - DISTRICT 3"},
    {"code": "40308", "area": "FAIR GROUND - BUCHANAN - DISTRICT 3"},
    {"code": "40309", "area": "GOD BLESS YOU HILL - BUCHANAN - DISTRICT 3"},
    {"code": "40310", "area": "WATCO CAMP - LOWER HARLANDSVILLE - DISTRICT 3"},
    {"code": "40311", "area": "NEW BUCHANAN - LOWER HARLANDSVILLE - DISTRICT 3"},
    {"code": "40312", "area": "JECKO TOWN - LOWER HARLANDSVILLE - DISTRICT 3"},
    {"code": "40313", "area": "EEKREEN - KEEKREEN - DISTRICT 3"},
    {"code": "40314", "area": "OWN YOUR OWN - KEEKREEN - DISTRICT 3"},
    {"code": "40315", "area": "CORN FAM - BUCHANAN - DISTRICT 3"},
    {"code": "40316", "area": "SUGAR CANE FARM - BUCHANAN - DISTRICT 3"},
    {"code": "40317", "area": "BIAFRA - BUCHANAN - DISTRICT 3"},
    {"code": "40318", "area": "FANTI TOWN - BUCHANAN - DISTRICT 3"},
    {"code": "40319", "area": "DIRT HOLE - BUCHANAN - DISTRICT 3"},
    {"code": "40320", "area": "SAYEPUE HILL - BUCHANAN - DISTRICT 3"},
    {"code": "40321", "area": "SUGAR HILL - BUCHANAN - DISTRICT 3"},
    {"code": "40401", "area": "GORBLEE - GORBLEE - DISTRICT 4"},
    {"code": "40402", "area": "BLEZEE - BLEZEE - DISTRICT 4"},
    {"code": "40403", "area": "DEEGBAH - BLEEZEE - DISTRICT 4"},
    {"code": "40404", "area": "ZONDO MISSION - ZONDO MISSION - DISTRICT 4"},
    {"code": "40405", "area": "NYUEIN_WEIN - NYUEIN_WEIN - DISTRICT 4"},
    {"code": "40501", "area": "WHROGBA - WHROGBA - DISTRICT 5"},
    {"code": "40502", "area": "DOEGBAHN_GLAYDOR - DOEGBAHN_GLAYDOR - DISTRICT 5"},
    {"code": "40503", "area": "KPOEWEIN - KPOEWEIN - DISTRICT 5"},
    {"code": "40504", "area": "PALM BAY - PALM BAY - DISTRICT 5"},
  ],
  "Margibi": [
    {"code": "20101", "area": "R2 COMMUNITY - DUAZON - MAMBAH KABA"},
    {"code": "20102", "area": "ROCK INTERNATIONAL - DUAZON - MAMBAH KABA"},
    {"code": "20103", "area": "DUAZON - DUAZON - MAMBAH KABA"},
    {"code": "20104", "area": "EBK BARRACKS - SCHIEFFLIN - MAMBAH KABA"},
    {"code": "20105", "area": "BOYS TOWN - SCHIEFFLIN - MAMBAH KABA"},
    {"code": "20106", "area": "SCHIEFFLIN - SCHIEFFLIN - MAMBAH KABA"},
    {"code": "20107", "area": "ELLEN ESTATE - SCHIEFFLIN - MAMBAH KABA"},
    {"code": "20108", "area": "MARSHALL - MARSHALL - MAMBAH KABA"},
    {"code": "20109", "area": "FARMINGTON - FARMINGTON - MAMBAH KABA"},
    {"code": "20110", "area": "KARFEAH - KARFEAH - MAMBAH KABA"},
    {"code": "20111", "area": "LOONGAYE - LOONGAYE - MAMBAH KABA"},
    {"code": "20112", "area": "ZOEDUEHN - ZOEDUEHN - MAMBAH KABA"},
    {"code": "20113", "area": "GARNOE - GARNOE - MAMBAH KABA"},
    {"code": "20114", "area": "GARZON - FARMINGTON - MAMBAH KABA"},
    {"code": "20115", "area": "LLOYDSVILLE CENTRAL - LOYDSVILLE - MAMBAH KABA"},
    {"code": "20201", "area": "UNIFICATION TOWN - UNIFICATION - MAMBAH KABA"},
    {"code": "20202", "area": "CENTRAL CHARLESVILLE - FARMINGTON - MAMBAH KABA"},
    {"code": "20203", "area": "DOLO TOWN - UNIFICATION - MAMBAH KABA"},
    {"code": "20204", "area": "COTTON TREE - UNIFICATION - MAMBAH KABA"},
    {"code": "20205", "area": "HARBEL - UNIFICATION - MAMBAH KABA"},
    {"code": "20206", "area": "GARZON WEST - FARMINTON - MAMBAH KABA"},
    {"code": "20301", "area": "DIVISION 25 - DIVISION 25 - FIRESTONE"},
    {"code": "20302", "area": "DIVISION 29 - CAMP 2 - FIRESTONE"},
    {"code": "20303", "area": "DIVISION 36 - CAMp 3 - FIRESTONE"},
    {"code": "20304", "area": "DIVISION 14 - CAMP 3 - FIRESTONE"},
    {"code": "20305", "area": "DIVISION 38 - OLD CAMP - FIRESTONE"},
    {"code": "20306", "area": "DIVISION 43 - CAMp - FIRESTONE"},
    {"code": "20307", "area": "DIVISION 24 - CAMP - FIRESTONE"},
    {"code": "20308", "area": "DIVISION 27 - FIRESTONE - FIRESTONE"},
    {"code": "20309", "area": "DU SIDE VILLAGE - DU SIDE - FIRESTONE"},
    {"code": "20401", "area": "DENNISVILLE COMMUNITY - KAKATA - KAKATA"},
    {"code": "20402", "area": "MENDE TOWN - KAKATA - KAKATA"},
    {"code": "20403", "area": "KRTTI - KAKATA - KAKATA"},
    {"code": "20404", "area": "BWI - KAKATA - KAKATA"},
    {"code": "20405", "area": "NANCY DOE - KAKATA - KAKATA"},
    {"code": "20406", "area": "ST. CHRISTOPHER - KAKATA - KAKATA"},
    {"code": "20407", "area": "CH RENNIE - KAKATA - KAKATA"},
    {"code": "20408", "area": "WHENNEY TOWN - KAKATA - KAKATA"},
    {"code": "20409", "area": "SUE TOWN - KAKATA - KAKATA"},
    {"code": "20410", "area": "BARCLAY - KAKATA - KAKATA"},
    {"code": "20411", "area": "MULA - KAKATA - KAKATA"},
    {"code": "20412", "area": "GBOYORMU - KAKATA - KAKATA"},
    {"code": "20413", "area": "JOHN HILL - KAKATA - KAKATA"},
    {"code": "20414", "area": "MORRIS FARM - KAKATA - KAKATA"},
    {"code": "20501", "area": "GALILA - GALILA - GIBI"},
    {"code": "20502", "area": "MASSAQUOI - MASSAQUOI - GIBI"},
    {"code": "20503", "area": "KPENEWEIN - KPENEWEIN - GIBI"},
    {"code": "20504", "area": "FAHNJACK - FAHNJACK - GIBI"},
  ],
  "Nimba": [
    {"code": "50101", "area": "NENGBE - NENGBE - GARR-BAIN"},
    {"code": "50102", "area": "GBUYEE - GBUYEE - GARR-BAIN"},
    {"code": "50103", "area": "TONGLAYWIN - TONGLAYWIN - GARR-BAIN"},
    {"code": "50104", "area": "DORMAH PA - DORMAH PA - GARR-BAIN"},
    {"code": "50105", "area": "YELEKORYEE - YELEKORYEE - GARR-BAIN"},
    {"code": "50106", "area": "GUINEA BORDER - GBUYEE - GARR-BAIN"},
    {"code": "50107", "area": "CITY VIEW - GANTA - GARR-BAIN"},
    {"code": "50108", "area": "ZOKESEH - GANTA - GARR-BAIN"},
    {"code": "50109", "area": "GEOLANDO - GANTA - GARR-BAIN"},
    {"code": "50110", "area": "TONGLAYWIN - GANTA - GARR-BAIN"},
    {"code": "50111", "area": "HOPE VILLAGE - GANTA - GARR-BAIN"},
    {"code": "50112", "area": "BLAGAYS - GANTA - GARR-BAIN"},
    {"code": "50113", "area": "DEAKEHMEIN - GANTA - GARR-BAIN"},
    {"code": "50114", "area": "GBUYEE - GANTA - GARR-BAIN"},
    {"code": "50115", "area": "J.W. PEARSON - GANTA - GARR-BAIN"},
    {"code": "50116", "area": "TOKAY HILL - GANTA - GARR-BAIN"},
    {"code": "50117", "area": "GLENYILUU - GANTA - GARR-BAIN"},
    {"code": "50118", "area": "REHAB TOWN - GANTA - GARR-BAIN"},
    {"code": "50119", "area": "LPMC - GANTA - GARR-BAIN"},
    {"code": "50201", "area": "GBOA - GBOA - SANNIQUELLIE-MAHN"},
    {"code": "50202", "area": "TONWEE - TONWEE - SANNIQUELLIE-MAHN"},
    {"code": "50203", "area": "SEHYI KIMPA - SEHYI KIMPA - SANNIQUELLIE-MAHN"},
    {"code": "50204", "area": "ZOLOWEE - ZOLOWEE - SANNIQUELLIE-MAHN"},
    {"code": "50205", "area": "NEIPA COMMUNITY - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50206", "area": "RED CROSS - SANNIQUEELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50207", "area": "BADIO TOWN - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50208", "area": "BAHA'I LOCAL - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50209", "area": "ARS COMPOUND - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50210", "area": "ST. MARRY HOSPITAL - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50211", "area": "JOY FM - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50212", "area": "NIMBA UNIVERSITY - SANNIQUELLIE - SANNIQUELLIE-MAHN"},
    {"code": "50213", "area": "GBAYEE - GBAYEE - YARPEA-MAHN"},
    {"code": "50214", "area": "GOTONWIN - GOTONWIN - YARPEA-MAHN"},
    {"code": "50215", "area": "BOAPLAY - BOAPLAY - YARPEA-MAHN"},
    {"code": "50216", "area": "MAO - MAO - YARPEA-MAHN"},
    {"code": "50301", "area": "ZOR KIALAY - ZOR KIALAY - GBEHLAY-GEH"},
    {"code": "50302", "area": "KARNPLAY - KARNPLAY - GBEHLAY-GEH"},
    {"code": "50303", "area": "DULAY - DULAY - GBEHLAY-GEH"},
    {"code": "50304", "area": "ZUALAY - ZUALAY - GBEHLAY-GEH"},
    {"code": "50305", "area": "GBAPA - GBAPA - GBEHLAY-GEH"},
    {"code": "50306", "area": "NEW YEKEPA - NEW YEKEPA - YARMEIN"},
    {"code": "50307", "area": "BONLA - BONLA - YARMEIN"},
    {"code": "50401", "area": "KORSEIN - KORSEIN - GBOR"},
    {"code": "50402", "area": "WEHPLAY - WEHPLAY - GBOR"},
    {"code": "50403", "area": "SAIPLAY - SAIPLAY - GBOR"},
    {"code": "50404", "area": "PAYEE - PAYEE - GBOR"},
    {"code": "50405", "area": "RLEKPORLAY - RLEKPORLAY - GBOR"},
    {"code": "50406", "area": "BAYLEHGLAY - BAYLEHGLAY - GBOR"},
    {"code": "50407", "area": "KPAIRPLAY - KPAIRPLAY - TWAN RIVER"},
    {"code": "50408", "area": "KEHLOW - KEHLOW - TWAN RIVER"},
    {"code": "50409", "area": "BEH - BEH - TWAN RIVER"},
    {"code": "50410", "area": "VAYENGLAY - VAYENGLAY - TWAN RIVER"},
    {"code": "50411", "area": "SENLAY - SENLAY - TWAN RIVER"},
    {"code": "50412", "area": "GBONWEA - GBONWEA - TWAN RIVER"},
    {"code": "50413", "area": "MAHDIAPLAY - MAHDIAPLAY - TWAN RIVER"},
    {"code": "50414", "area": "GARPLAY - GARPLAY - TWAN RIVER"},
    {"code": "50415", "area": "DUAH - DUAH - TWAN RIVER"},
    {"code": "50416", "area": "GBEI BONNAH - GBEI BONNAH - TWAN RIVER"},
    {"code": "50417", "area": "GBLANLAY - GBLANLAY - TWAN RIVER"},
    {"code": "50418", "area": "GBEI VONWEA - GBEI VONWEA - TWAN RIVER"},
    {"code": "50419", "area": "GBORPLAY - GBORPLAY - TWAN RIVER"},
    {"code": "50420", "area": "LONTUO - LONTUO - TWAN RIVER"},
    {"code": "50421", "area": "BONGARPLAY - BONGARPLAY - TWAN RIVER"},
    {"code": "50501", "area": "BEATATUO - BEATATUO - BUU-YAO"},
    {"code": "50502", "area": "BEEPLAY - BEEPLAY - BUU-YAO"},
    {"code": "50503", "area": "GLARLAY - GLARLAY - BUU-YAO"},
    {"code": "50504", "area": "TIAPLAY - TIAPLAY - BUU-YAO"},
    {"code": "50505", "area": "NYARLAY - NYARLAY - BUU-YAO"},
    {"code": "50506", "area": "ZUAHPLAY - ZUAHPLAY - BUU-YAO"},
    {"code": "50507", "area": "YAO LEPULA - YAO LEPULA - BUU-YAO"},
    {"code": "50508", "area": "DIAPLAY - DIAPLAY - BUU-YAO"},
    {"code": "50509", "area": "GBANWEA - GBANWEA - BUU-YAO"},
    {"code": "50510", "area": "DINPLAY - DINPLAY - BUU-YAO"},
    {"code": "50511", "area": "TEAHPLAY - TEAHPLAY - BUU-YAO"},
    {"code": "50512", "area": "BIAHPLAY - BIAHPLAY - BUU-YAO"},
    {"code": "50513", "area": "TANWEA - TANWEA - BUU-YAO"},
    {"code": "50514", "area": "BUUTUO - BUUTUO - BUU-YAO"},
    {"code": "50515", "area": "GOMAHPLAY - GOMAHPLAY - BUU-YAO"},
    {"code": "50516", "area": "BLEMIEPLAY - BLEMIEPLAY - BUU-YAO"},
    {"code": "50601", "area": "TOWEH - TOWEH - BOE & QUILLA"},
    {"code": "50602", "area": "SARLAY - SARLAY - BOE & QUILLA"},
    {"code": "50603", "area": "MARLAY - MARLAY - BOE & QUILLA"},
    {"code": "50604", "area": "GAYEA - GAYEA - KPARBLEE"},
    {"code": "50605", "area": "DUBUZON - DUBUZON - KPARBLEe"},
    {"code": "50606", "area": "TAPPITA - TAPPITA - DOE"},
    {"code": "50607", "area": "VAHN - VAHN - DOE"},
    {"code": "50608", "area": "KWIPEA - KWIPEA - DOE"},
    {"code": "50701", "area": "KPAYTUO - KPAYTUO - WEE-GBEHYI"},
    {"code": "50702", "area": "LOYEE - LOYEE - WEE-GBEHYI"},
    {"code": "50703", "area": "FLEEDIN - FLEEDIN - WEE-GBEHYI"},
    {"code": "50704", "area": "GUAWIN - GUAWIN - WEE-GBEHYI"},
    {"code": "50705", "area": "NYAO - NYAO - WEE-GBEHYI"},
    {"code": "50706", "area": "NYANSIN - NYANSIN - WEE-GBEHYI"},
    {"code": "50707", "area": "GBANQUOI - GBANQUOI - WEE-GBEHYI"},
    {"code": "50708", "area": "SANQUOI - SANQUOI - WEE-GBEHYI"},
    {"code": "50709", "area": "BUEH - BUEH - WEE-GBEHYI"},
    {"code": "50710", "area": "MEHNPA - MEHNPA - WEE-GBEHYI"},
    {"code": "50711", "area": "TROUPOE - TROUPOE - ZOE-GBAO"},
    {"code": "50712", "area": "BUANPLAY - BUANPLAY - ZOE-GBAO"},
    {"code": "50713", "area": "BEHYEPEA - BEHYEPEA - ZOE-GBAO"},
    {"code": "50714", "area": "ZANTUO - ZANTUO - ZOE-GBAO"},
    {"code": "50715", "area": "BAHN - BAHN CITY - ZOE-GBAO"},
    {"code": "50716", "area": "BUU-GBOR - BUU-GBOR - ZOE-GBAO"},
    {"code": "50717", "area": "GBLAH - GBLAH - ZOE-GBAO"},
    {"code": "50718", "area": "MIAPLAY - MIAPLAY - ZOE-GBAO"},
    {"code": "50719", "area": "ZAYGLAY - ZAYGLAY - ZOE-GBAO"},
    {"code": "50720", "area": "GORLAY - GORLAY - ZOE-GBAO"},
    {"code": "50721", "area": "ZOE-LUAPA - ZOE-LUAPA - ZOE-GBAO"},
    {"code": "50801", "area": "GAMPA - GAMPA - MEINPEA-MAHN"},
    {"code": "50802", "area": "BANLAH - BANLAH - MEINPEA-MAHN"},
    {"code": "50803", "area": "TONWIN - TONWIN - MEINPEA-MAHN"},
    {"code": "50804", "area": "BUNADIN - BUNADIN - MEINPEA-MAHN"},
    {"code": "50805", "area": "GARNWIN - GARNWIN - MEINPEA-MAHN"},
    {"code": "50806", "area": "TINYEE - TINYEE - MEINPEA-MAHN"},
    {"code": "50807", "area": "SOKOPA - SOKOPA - MEINPEa-MAHN"},
    {"code": "50808", "area": "GBLEHYEE - GBLEHYEE - MEINPEA-MAHN"},
    {"code": "50809", "area": "KPEIN - KPEIN - MEINPEA-MAHN"},
    {"code": "50810", "area": "TUNUKPUYEE - TUNUKPUYEE - MEINPEA-MAHN"},
    {"code": "50811", "area": "WHENTEN - WHENTEN - LEEWEHPEA-MAHN"},
    {"code": "50812", "area": "GIPO - GIPO - LEEWEHPEA-MAHN"},
    {"code": "50813", "area": "FLUMPA - FLUMPA - LEEWEHPEA-MAHN"},
    {"code": "50814", "area": "BLOHN - BLOHN - LEEWEHPEA-MAHN"},
    {"code": "50815", "area": "BINDIN - BINDIN - LEEWEHPEA-MAHN"},
    {"code": "50816", "area": "DOHN - DOHN - LEEWEHPEA-MAHN"},
    {"code": "50817", "area": "KPALLAH - KPALLAH - LEEWEHPEA-MAHN"},
    {"code": "50901", "area": "ZAROGBO - ZAROGBO - GBI & DORU"},
    {"code": "50902", "area": "ZEEWROH - ZEEWROH - GBI & DORU"},
    {"code": "50903", "area": "WONTOE - WONTOE - GBI & DORU"},
    {"code": "50904", "area": "ZAHN ZAYEE - ZAHN ZAYEE - YARWEIN-MEHNSONOH"},
    {"code": "50905", "area": "ZEKEPA - ZEKEPA - YARWEIN-MEHNSONOH"},
  ],
  "Lofa": [
    {"code": "60101", "area": "NDAMA - NDAMA - FOYA"},
    {"code": "60102", "area": "KONKPAMA - KONKPAMA - FOYA"},
    {"code": "60103", "area": "FOYA - FOYA CITY - FOYA"},
    {"code": "60104", "area": "FASSAPOE - FASSAPOE - FOYA"},
    {"code": "60105", "area": "SINAGOLE - SINAGOLE - FOYA"},
    {"code": "60106", "area": "NDEHUMA - NDEHUMA - FOYA"},
    {"code": "60107", "area": "YELAYALOE - YELAYALOE - FOYA"},
    {"code": "60108", "area": "BORLILOE - BORLILOE - FOYA"},
    {"code": "60109", "area": "BANDENIN - BANDENIN - FOYA"},
    {"code": "60110", "area": "BANDENIN MELIMU - BANDENIN MELIMU - FOYA"},
    {"code": "60111", "area": "LEPALOE - LEPALOE - FOYA"},
    {"code": "60201", "area": "KORTUMA - KORTUMA - VAHUN"},
    {"code": "60202", "area": "VAHUN - VAHUN CITY - VAHUN"},
    {"code": "60203", "area": "UPPER GUMA - UPPER GUMA - VAHUN"},
    {"code": "60204", "area": "KAMATAHUN - KAMATAHUN - WANHASSA"},
    {"code": "60205", "area": "POPALAHUN - POPALAHUN - WANHASSA"},
    {"code": "60206", "area": "LEHUMA - LEHUMA - WANHASSA"},
    {"code": "60208", "area": "KIMBALOE - KIMBALOE - FOYA"},
    {"code": "60301", "area": "YASELAHUN - YASELAHUN - KOLAHUN"},
    {"code": "60302", "area": "BOWAHUN - BOWAHUN - KOLAHUN"},
    {"code": "60303", "area": "PASOLAHUN - PASOLAHUN - KOLAHUN"},
    {"code": "60304", "area": "KAMBOLAHUN - KAMBOLAHUN - KOLAHUN"},
    {"code": "60305", "area": "SOMALAHUN - SOMALAHUN - KOLAHUN"},
    {"code": "60401", "area": "KONIA - KONIA - ZORZOR"},
    {"code": "60402", "area": "BARZIWEN - BARZIWEN - ZORZOR"},
    {"code": "60403", "area": "KARZAH - KARZAH - VOINJAMA"},
    {"code": "60404", "area": "ZOGOLEMAI - ZOGOLEMAI - VOINJAMA"},
    {"code": "60405", "area": "DAYZABAH - DAYZabah - VOINJAMA"},
    {"code": "60406", "area": "KESSELEMAI - KESSELEMAI - VOINJAMA"},
    {"code": "60407", "area": "WARBALAMAI - WARBALAMAI - VOINJAMA"},
    {"code": "60408", "area": "VOINJAMA - VOINJAMA - VOINJAMA"},
    {"code": "60409", "area": "WANGLODU - WANGLODU - QUARDU GBONI"},
    {"code": "60410", "area": "BARKEDU - BARKEDU - QUARDU GBONI"},
    {"code": "60411", "area": "SYLAKORLOR - SYLAKORLOR - QUARDU GBONI"},
    {"code": "60412", "area": "WOMAMA - WOMAMA - QUARDU GBONI"},
    {"code": "60413", "area": "SAYGBAMA - SAYGBAMA - QUARDU GBONI"},
    {"code": "60501", "area": "KPETEYEA - KPETEYEA - SALAYEA"},
    {"code": "60502", "area": "GANGLOTA - GONGLOTA - SALAYEA"},
    {"code": "60503", "area": "GBONYEA - GBONYEA - SALAYEA"},
    {"code": "60504", "area": "SALAYEA - SALAYEA - SALAYEA"},
    {"code": "60505", "area": "TAILEMAI - TAILEMAI - SALAYEA"},
    {"code": "60506", "area": "SUCROMU - SUCROMU - SALAYEA"},
    {"code": "60507", "area": "KPAIYEA - KPAIYEA - SALAYEA"},
    {"code": "60508", "area": "FASSAWALAZU - FASSAWALAZU - ZORZOR"},
    {"code": "60509", "area": "ZOLOWO - ZOLOWO - ZORZOR"},
    {"code": "60510", "area": "KILEWU - KILEWU - ZORZOR"},
    {"code": "60511", "area": "ZORZOR - ZORZOR - ZORZOR"},
    {"code": "60512", "area": "YEALA - YEALA - ZORZOR"},
    {"code": "60513", "area": "FISSIBU - FISSIBU - ZORZOR"},
    {"code": "60514", "area": "BALOMA - BALOMA - ZORZOR"},
    {"code": "60515", "area": "WOULOWUMO - WOULOWUMO - ZORZOR"},
    {"code": "60516", "area": "WUOMAI - WUOMAI - ZORZOR"},
    {"code": "60517", "area": "BALAGWALAZU - BALAGWALAZU - ZORZOR"},
    {"code": "60518", "area": "BODAH - BODAH - ZORZOR"},
    {"code": "60519", "area": "WANLEIMA - WANLEIMA - ZORZOR"},
    {"code": "60520", "area": "ZELEMAI - ZELEMAI - ZORZOR"},
    {"code": "60521", "area": "BORKEZA - BORKEZA - ZORZOR"},
    {"code": "60522", "area": "WARKESU - WARKESU - ZORZOR"},
    {"code": "60523", "area": "ZIGGIDA - ZIGGIDA - ZORZOR"},
  ],
  "Bomi": [
    {"code": "71101", "area": "BESAO - BESAO - SENJEH"},
    {"code": "71102", "area": "GAYAH HILL - GAYAH HILL - SENJEH"},
    {"code": "71103", "area": "BAIMA - BAIMA - SENJEH"},
    {"code": "71104", "area": "BEAJAH - BEAJAH - SENJEH"},
    {"code": "71105", "area": "WEAKAMA - WEAKAMA - SENJEH"},
    {"code": "71106", "area": "BEAFINIE - BEAFINIE - SENJEH"},
    {"code": "71107", "area": "ZAMIAH - ZAMIAH - SENJEH"},
    {"code": "71108", "area": "BARMO - BARMO - SENJEH"},
    {"code": "71109", "area": "TUBMANBURG - TUBMANBURG - SENJEH"},
    {"code": "71110", "area": "MAHER - MAHER - SENJEH"},
    {"code": "71111", "area": "BOLA - BOLA - SENJEH"},
    {"code": "71112", "area": "SACKIE - SACKIE - SENJEH"},
    {"code": "71201", "area": "KOWADEE - KOWADEE - KLAY"},
    {"code": "71202", "area": "GOGEHN - GOGEHN - KLAY"},
    {"code": "71203", "area": "GUIE - GUIE - KLAY"},
    {"code": "71204", "area": "SIEH - SIEH - KLAY"},
    {"code": "71205", "area": "MALEMA - MALEMA - KLAY"},
    {"code": "71206", "area": "MAMJAMA - MAMJAMA - DOWEIN"},
    {"code": "71208", "area": "VORTOR - VORTOR - DOWEIN"},
    {"code": "71209", "area": "GBAIGBON - GBAIGBON - DOWEIN"},
    {"code": "71301", "area": "MECCA - MECCA - SUEHN MECCA"},
    {"code": "71302", "area": "MALOMA - MALOMA - SUEHN MECCA"},
    {"code": "71303", "area": "SONODEE - SONODEE - SUEHN MECCA"},
    {"code": "71304", "area": "SUEHN - SUEHN - SUEHN MECCA"},
    {"code": "71305", "area": "BEYAN - BEYAN - SUEHN MECCA"},
    {"code": "71306", "area": "VINCENT - VINCENT - DOWEIN"},
    {"code": "71307", "area": "JENNEH - JENNEH - DOWEIN"},
    {"code": "71308", "area": "BONOR - BONOR - DOWEIN"},
  ],
  "Gbarpolu": [
    {"code": "72101", "area": "BOMBOMAH - BOMBOMAH - BOPOLU"},
    {"code": "72102", "area": "LOWER BONDI MANDINGO - LOWER BONDI MANDINGO - BOPOLU"},
    {"code": "72103", "area": "UPPER BONDI MANDINGO - UPPER BONDI MANDINGO - BOPOLU"},
    {"code": "72104", "area": "GONGBAYAH - GONGBAYAH - BOPOLU"},
    {"code": "72105", "area": "MEDINA - BOPOLU - BOPOLU"},
    {"code": "72106", "area": "DORLEHLALA - BOPOLU - BOPOLU"},
    {"code": "72107", "area": "LOWOMAH - BOPOLU - BOPOLU"},
    {"code": "72108", "area": "SAPPIMAH - BOPOLU - BOPOLU"},
    {"code": "72109", "area": "FARWEHNTA CENTRAL - BOPOLU - BOPOLU"},
    {"code": "72110", "area": "GUYAN-TA - BOPOLU - BOPOLU"},
    {"code": "72111", "area": "TAWALATA - TAWALATA - BOPOLU"},
    {"code": "72201", "area": "FASSAMA - FASSAMA - BELLEH"},
    {"code": "72202", "area": "BELLEH YALLAH - BELLEH YALLAH - BELLEH"},
    {"code": "72203", "area": "KPAWOLOWU - KPAWOLOWU - BELLEH"},
    {"code": "72204", "area": "BALOMA - BALOMA - BELLEH"},
    {"code": "72205", "area": "GATIMA - GATIMA - BELLEH"},
    {"code": "72206", "area": "TIGGELEE - TIGGELEE - BELLEH"},
    {"code": "72207", "area": "GOMU - GOMU - GOUNWOLAILA"},
    {"code": "72208", "area": "KELLEH - KELLEH - GOUNWOLAILa"},
    {"code": "72209", "area": "GOU - GOU - GOUNWOLAILA"},
    {"code": "72210", "area": "ZEAYEA - ZEAYEA - GOUNWOLAILA"},
    {"code": "72211", "area": "ZALAKAI - ZALAKAI - BOKOMU"},
    {"code": "72212", "area": "SALAYAH - SALAYAH - BOKOMU"},
    {"code": "72213", "area": "MOILAKWELLE - MOILAKWELLE - BOKOMU"},
    {"code": "72214", "area": "GBELLETA - GBELLETA - BOKOMU"},
    {"code": "72301", "area": "WEASUA - WEASUA - GBARMA"},
    {"code": "72302", "area": "BALLAH & BASSA - BALLAH & BASSA - GBARMA"},
    {"code": "72303", "area": "SMITH - SMITH - GBARMA"},
    {"code": "72304", "area": "SIRLEAF - SIRLEAF - GBARMA"},
    {"code": "72305", "area": "BEATOE - BEATOE - GBARMA"},
    {"code": "72306", "area": "BEADEN - BEADEN - KONGBA"},
    {"code": "72307", "area": "GBAR - GBAR - KONGBA"},
    {"code": "72308", "area": "ZUIE - ZUIE - KONGBA"},
    {"code": "72309", "area": "BEATHOU - BEATHOU - KONGBA"},
    {"code": "72310", "area": "JAWAJAH - JAWAJAH - KONGBA"},
    {"code": "72311", "area": "KUNGBOR - KUNGBOR - KONGBA"},
    {"code": "72312", "area": "PAMBAYA - PAMBAYA - KONGBA"},
    {"code": "72313", "area": "NOMODATANAU - NOMODATANAU - KONGBA"},
  ],
  "Grand Cape Mount": [
    {"code": "73101", "area": "JENNEMANA - JANNEMANA - GOLA KONNEH"},
    {"code": "73102", "area": "GONDOR - GONDOR - GOLA KONNEH"},
    {"code": "73103", "area": "TAHN - TAHN - GOLA KONNEH"},
    {"code": "73104", "area": "MECCA - MECCA - GOLA KONNEH"},
    {"code": "73105", "area": "MANAGORDUAH - MANAGORDUAH - GOLA KONNEH"},
    {"code": "73106", "area": "FULAH CAMP - FUALH CAMP - PORKPA"},
    {"code": "73107", "area": "SOKPO - SOKPO - PORKPA"},
    {"code": "73108", "area": "KONGO - KONGO - PORKPA"},
    {"code": "73109", "area": "BUNDUMA - BUNDUMA - PORKPA"},
    {"code": "73110", "area": "JEIJUAH - JEIJUAH - PORKPA"},
    {"code": "73111", "area": "SEIMAVULA - SEIMAVULA - PORKPA"},
    {"code": "73201", "area": "GRASS FIELD - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73202", "area": "KRU TOWN - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73203", "area": "CENTRAL ROBERTSPORT - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73204", "area": "UP TOWN - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73205", "area": "GONBOJAH - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73206", "area": "LONDIJAI - ROBERTSPORT - ROBERTSPORT"},
    {"code": "73207", "area": "GBASSALOR - ROBRTSPORT - ROBERTSPORT"},
    {"code": "73208", "area": "KIAZOLU - KIAZOLU - GARWULA"},
    {"code": "73209", "area": "GION - GION - GARWULA"},
    {"code": "73210", "area": "ZOEGBOE - ZOEGBOE - GARWULA"},
    {"code": "73211", "area": "ZODUA - ZODUA - GARWULA"},
    {"code": "73301", "area": "SAMBOLA - SAMBOLA - TEWOR"},
    {"code": "73302", "area": "KIAWU - KIAWU - TEWOR"},
    {"code": "73303", "area": "FAHNBULLEH - FAHNBULLEH - TEWOR"},
    {"code": "73304", "area": "PASSAWE - PASSAWE - TEWOR"},
    {"code": "73305", "area": "MENDE-MASSA - MENDE-MASSA - TEWOR"},
    {"code": "73306", "area": "KROMAH - KROMAH - TEWOR"},
    {"code": "73307", "area": "BO WATERSIDE - BO WATERSIDE - TEWOR"},
  ],
};

const API_URL = process.env.REACT_APP_API_URL || 'https://api.liberianpost.com';

const KYCVerification: React.FC = () => {
  const { token, employee } = useAuth();
  const [pendingKYC, setPendingKYC] = useState<KYCUser[]>([]);
  const [verifiedKYC, setVerifiedKYC] = useState<KYCUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState<KYCUser | null>(null);
  const [dssn, setDssn] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<'pending' | 'verified'>('pending');

  // Registration Flow State
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [registrationType, setRegistrationType] = useState<'user' | 'merchant'>('user');
  const [registerLoading, setRegisterLoading] = useState(false);
  const [registerError, setRegisterError] = useState('');

  // Register Form State - Full User Schema
  const [registerForm, setRegisterForm] = useState<RegisterFormData>({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    date_of_birth: '',
    place_of_birth: '',
    nationality: 'Liberian',
    marital_status: '',
    employment_status: '',
    number_of_children: 0,
    sex: '',
    address: '',
    postal_address: '',
    passport_number: '',
    birth_certificate: '',
    driver_license: '',
    image: '',
    passport_image: '',
    birth_certificate_image: '',
    drivers_license_image: '',
    national_id_image: '',
    username: '',
    display_name: '',
    bio: '',
  });

  // Stats
  const [stats, setStats] = useState({
    totalRegistered: 0,
    pendingVerification: 0,
    verifiedUsers: 0,
    dssnAssigned: 0
  });

  // Postal code state
  const [selectedCounty, setSelectedCounty] = useState('');
  const [availablePostalCodes, setAvailablePostalCodes] = useState<Array<{ code: string; area: string }>>([]);

  useEffect(() => {
    fetchPendingKYC();
    fetchVerifiedKYC();
    fetchStats();
  }, []);

  const fetchPendingKYC = async () => {
    try {
      const response = await axios.get(`${API_URL}/employees/kyc/pending`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setPendingKYC(response.data.data?.pending_kyc || []);
    } catch (error) {
      console.error('Failed to fetch pending KYC:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchVerifiedKYC = async () => {
    try {
      const response = await axios.get(`${API_URL}/employees/kyc/verified`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setVerifiedKYC(response.data.data?.verified_kyc || []);
    } catch (error) {
      console.error('Failed to fetch verified KYC:', error);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/employees/kyc/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setStats(response.data.data?.stats || {
        totalRegistered: 0,
        pendingVerification: 0,
        verifiedUsers: 0,
        dssnAssigned: 0
      });
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  // Handle county change for postal codes
  const handleCountyChange = (county: string) => {
    setSelectedCounty(county);
    setRegisterForm(prev => ({ ...prev, postal_address: '' }));
    if (POSTAL_CODES[county]) {
      setAvailablePostalCodes(POSTAL_CODES[county]);
    } else {
      setAvailablePostalCodes([]);
    }
  };

  // Generate DSSN
  const generateDSSN = (firstName: string, lastName: string, dob: string = '940924') => {
    const firstPart = firstName.substring(0, 3).toUpperCase().padEnd(3, 'X');
    const lastPart = lastName.substring(0, 3).toUpperCase().padEnd(3, 'X');
    const year = dob.substring(2, 4) || '94';
    const month = dob.substring(4, 6) || '09';
    const day = dob.substring(6, 8) || '24';
    const securityCode = 'Z';
    return `${firstPart}${lastPart}${year}LR${month}${securityCode}${day}`;
  };

  // Handle registration submission
  const handleRegisterUser = async (e: React.FormEvent) => {
    e.preventDefault();
    setRegisterError('');
    setRegisterLoading(true);

    try {
      // Validate required fields
      const requiredFields = ['first_name', 'last_name', 'email', 'phone', 'password'];
      const missingFields = requiredFields.filter(field => !registerForm[field as keyof RegisterFormData]);
      
      if (missingFields.length > 0) {
        setRegisterError(`Missing required fields: ${missingFields.join(', ')}`);
        setRegisterLoading(false);
        return;
      }

      // Format date of birth for API
      let formattedDob = registerForm.date_of_birth;
      if (registerForm.date_of_birth && registerForm.date_of_birth.includes('-')) {
        const parts = registerForm.date_of_birth.split('-');
        if (parts.length === 3) {
          formattedDob = `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
      }

      // Generate DSSN if not provided
      const dssnValue = generateDSSN(registerForm.first_name, registerForm.last_name, 
        registerForm.date_of_birth.replace(/-/g, ''));

      // Prepare payload
      const payload = {
        ...registerForm,
        date_of_birth: formattedDob,
        dssn: dssnValue,
      };

      const response = await axios.post(`${API_URL}/employees/users/register`, payload, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.success) {
        alert(`✅ User ${registerForm.first_name} ${registerForm.last_name} registered successfully!\nDSSN: ${dssnValue}`);
        setShowRegistrationModal(false);
        resetRegisterForm();
        fetchPendingKYC();
        fetchVerifiedKYC();
        fetchStats();
      }
    } catch (error: any) {
      setRegisterError(error.response?.data?.error || 'Registration failed');
    } finally {
      setRegisterLoading(false);
    }
  };

  const resetRegisterForm = () => {
    setRegisterForm({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      date_of_birth: '',
      place_of_birth: '',
      nationality: 'Liberian',
      marital_status: '',
      employment_status: '',
      number_of_children: 0,
      sex: '',
      address: '',
      postal_address: '',
      passport_number: '',
      birth_certificate: '',
      driver_license: '',
      image: '',
      passport_image: '',
      birth_certificate_image: '',
      drivers_license_image: '',
      national_id_image: '',
      username: '',
      display_name: '',
      bio: '',
    });
    setSelectedCounty('');
    setAvailablePostalCodes([]);
    setRegisterError('');
  };

  const approveKYC = async () => {
    if (!selectedUser) return;
    if (!dssn) {
      alert('Please enter a DSSN for this user');
      return;
    }

    setActionLoading(true);
    try {
      await axios.post(`${API_URL}/employees/users/assign-dssn`, {
        user_uuid: selectedUser.uuid,
        dssn: dssn
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      alert(`✅ DSSN ${dssn} assigned to ${selectedUser.first_name} ${selectedUser.last_name}`);
      setSelectedUser(null);
      setDssn('');
      fetchPendingKYC();
      fetchVerifiedKYC();
      fetchStats();
    } catch (error: any) {
      alert(error.response?.data?.error || 'Failed to assign DSSN');
    } finally {
      setActionLoading(false);
    }
  };

  const rejectKYC = async () => {
    if (!selectedUser) return;
    if (!rejectionReason) {
      alert('Please provide a reason for rejection');
      return;
    }

    setActionLoading(true);
    try {
      await axios.post(`${API_URL}/employees/kyc/reject`, {
        user_uuid: selectedUser.uuid,
        rejection_reason: rejectionReason
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      alert(`❌ KYC for ${selectedUser.first_name} ${selectedUser.last_name} has been rejected`);
      setSelectedUser(null);
      setRejectionReason('');
      fetchPendingKYC();
      fetchStats();
    } catch (error: any) {
      alert(error.response?.data?.error || 'Failed to reject KYC');
    } finally {
      setActionLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="kyc-dashboard">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Loading KYC Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="kyc-dashboard">
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="header-left">
          <h1>KYC Verification Center</h1>
          <p className="header-subtitle">AI-powered identity verification and digital security number management</p>
        </div>
        <div className="header-right">
          <div className="ai-badge">
            <FiCpu />
            <span>AI Analysis Active</span>
          </div>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FiUsers className="stat-icon" />
            <span className="stat-trend positive">+12%</span>
          </div>
          <div className="stat-info">
            <h3>{stats.totalRegistered}</h3>
            <p>Total Registered Users</p>
            <span className="stat-subtitle">Last 30 days</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FiClock className="stat-icon" />
            <span className="stat-trend">{stats.pendingVerification}</span>
          </div>
          <div className="stat-info">
            <h3>{stats.pendingVerification}</h3>
            <p>Pending Verification</p>
            <span className="stat-subtitle">Awaiting review</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FiUserCheck className="stat-icon" />
            <span className="stat-trend positive">+{stats.verifiedUsers}</span>
          </div>
          <div className="stat-info">
            <h3>{stats.verifiedUsers}</h3>
            <p>Verified Users</p>
            <span className="stat-subtitle">KYC completed</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <FiHash className="stat-icon" />
            <span className="stat-trend positive">+{stats.dssnAssigned}</span>
          </div>
          <div className="stat-info">
            <h3>{stats.dssnAssigned}</h3>
            <p>DSSN Assigned</p>
            <span className="stat-subtitle">Digital Security Numbers</span>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          <div className="action-card" onClick={() => { setRegistrationType('user'); setShowRegistrationModal(true); }}>
            <div className="action-icon user">
              <FiUserPlus />
            </div>
            <div className="action-info">
              <h3>Register User</h3>
              <p>Complete user registration with all details</p>
            </div>
            <div className="action-arrow">→</div>
          </div>
          <div className="action-card" onClick={() => { setRegistrationType('merchant'); setShowRegistrationModal(true); }}>
            <div className="action-icon merchant">
              <FiBriefcase />
            </div>
            <div className="action-info">
              <h3>Register Merchant</h3>
              <p>Register a new merchant account</p>
            </div>
            <div className="action-arrow">→</div>
          </div>
          <div className="action-card" onClick={() => setActiveTab('pending')}>
            <div className="action-icon verify">
              <FiShield />
            </div>
            <div className="action-info">
              <h3>Verify User KYC</h3>
              <p>Review pending verifications</p>
            </div>
            <div className="action-arrow">→</div>
          </div>
        </div>
      </div>

      {/* KYC Lists */}
      <div className="recent-activity">
        <div className="activity-header">
          <h2>{activeTab === 'pending' ? 'Pending Verification Requests' : 'Verified Users & DSSN'}</h2>
          <div className="tab-switch">
            <button 
              className={`tab-btn ${activeTab === 'pending' ? 'active' : ''}`} 
              onClick={() => setActiveTab('pending')}
            >
              <FiClock /> Pending ({pendingKYC.length})
            </button>
            <button 
              className={`tab-btn ${activeTab === 'verified' ? 'active' : ''}`} 
              onClick={() => setActiveTab('verified')}
            >
              <FiUserCheck /> Verified ({verifiedKYC.length})
            </button>
          </div>
        </div>

        {activeTab === 'pending' && (
          pendingKYC.length === 0 ? (
            <div className="empty-state">
              <FiShieldOff size={48} />
              <h3>No Pending KYC Requests</h3>
              <p>All user verifications have been processed</p>
            </div>
          ) : (
            <div className="kyc-grid">
              {pendingKYC.map((user) => (
                <div key={user.uuid} className="kyc-card">
                  <div className="kyc-card-header">
                    <div className="kyc-avatar">{user.first_name.charAt(0)}{user.last_name.charAt(0)}</div>
                    <div className="kyc-user-info">
                      <h3>{user.first_name} {user.last_name}</h3>
                      <p>{user.email}</p>
                      <p>{user.phone}</p>
                    </div>
                  </div>
                  <div className="kyc-card-details">
                    <div className="kyc-detail">
                      <span>Submitted:</span>
                      <strong>{new Date(user.created_at).toLocaleDateString()}</strong>
                    </div>
                    <div className="kyc-detail">
                      <span>Status:</span>
                      <span className="kyc-status pending">Pending Review</span>
                    </div>
                  </div>
                  <div className="kyc-card-actions">
                    <button className="kyc-btn view" onClick={() => setSelectedUser(user)}>
                      <FiEye /> Review Documents
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {activeTab === 'verified' && (
          verifiedKYC.length === 0 ? (
            <div className="empty-state">
              <FiUserCheck size={48} />
              <h3>No Verified Users Yet</h3>
              <p>Verified users will appear here after KYC approval</p>
            </div>
          ) : (
            <div className="kyc-grid">
              {verifiedKYC.map((user) => (
                <div key={user.uuid} className="kyc-card verified">
                  <div className="kyc-card-header">
                    <div className="kyc-avatar verified">{user.first_name.charAt(0)}{user.last_name.charAt(0)}</div>
                    <div className="kyc-user-info">
                      <h3>{user.first_name} {user.last_name}</h3>
                      <p>{user.email}</p>
                      <p>{user.phone}</p>
                    </div>
                  </div>
                  <div className="kyc-card-details">
                    <div className="kyc-detail">
                      <span>Verified:</span>
                      <strong>{new Date(user.created_at).toLocaleDateString()}</strong>
                    </div>
                    <div className="kyc-detail">
                      <span>Status:</span>
                      <span className="kyc-status verified">✓ Verified</span>
                    </div>
                  </div>
                  <div className="kyc-card-actions">
                    <button className="kyc-btn assign-dssn" onClick={() => { 
                      setSelectedUser(user); 
                      setDssn(generateDSSN(user.first_name, user.last_name)); 
                    }}>
                      <FiHash /> Assign DSSN
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>

      {/* KYC Review Modal */}
      {selectedUser && (
        <div className="modal-overlay" onClick={() => setSelectedUser(null)}>
          <div className="modal-content kyc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2><FiShield /> Review KYC Application</h2>
              <button className="close-modal-btn" onClick={() => setSelectedUser(null)}>×</button>
            </div>
            <div className="user-detail-info">
              <div className="detail-row">
                <span className="detail-label">Full Name:</span>
                <span>{selectedUser.first_name} {selectedUser.last_name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Email:</span>
                <span>{selectedUser.email}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Phone:</span>
                <span>{selectedUser.phone}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Submitted:</span>
                <span>{new Date(selectedUser.created_at).toLocaleString()}</span>
              </div>
            </div>
            <div className="dssn-input-group">
              <label>Digital Security Social Number (DSSN)</label>
              <div className="dssn-input-wrapper">
                <input 
                  type="text" 
                  placeholder="e.g., DOEJOH94LR09Z24" 
                  value={dssn} 
                  onChange={(e) => setDssn(e.target.value.toUpperCase())} 
                  className="glass-input" 
                />
                <button 
                  className="generate-dssn-btn" 
                  onClick={() => setDssn(generateDSSN(selectedUser.first_name, selectedUser.last_name))}
                >
                  <FiHash /> Generate
                </button>
              </div>
            </div>
            <div className="rejection-input-group">
              <label>Rejection Reason (if rejecting)</label>
              <textarea 
                placeholder="Enter reason for rejection..." 
                value={rejectionReason} 
                onChange={(e) => setRejectionReason(e.target.value)} 
                className="glass-textarea" 
                rows={3} 
              />
            </div>
            <div className="kyc-modal-actions">
              <button className="kyc-approve-btn" onClick={approveKYC} disabled={actionLoading}>
                {actionLoading ? <FiLoader className="spinning" /> : <FiCheck />}
                Approve & Assign DSSN
              </button>
              <button className="kyc-reject-btn" onClick={rejectKYC} disabled={actionLoading}>
                {actionLoading ? <FiLoader className="spinning" /> : <FiX />}
                Reject Application
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Registration Modal */}
      {showRegistrationModal && (
        <div className="modal-overlay" onClick={() => setShowRegistrationModal(false)}>
          <div className="modal-content registration-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>
                {registrationType === 'user' ? (
                  <><FiUserPlus /> Register New User</>
                ) : (
                  <><FiBriefcase /> Register New Merchant</>
                )}
              </h2>
              <button className="close-modal-btn" onClick={() => setShowRegistrationModal(false)}>×</button>
            </div>

            <form onSubmit={handleRegisterUser} className="register-form-scrollable">
              {/* SECTION 1: Personal Information */}
              <div className="form-section">
                <h3><FiUser /> Personal Information</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input
                      type="text"
                      placeholder="Enter first name"
                      value={registerForm.first_name}
                      onChange={(e) => setRegisterForm({ ...registerForm, first_name: e.target.value })}
                      required
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input
                      type="text"
                      placeholder="Enter last name"
                      value={registerForm.last_name}
                      onChange={(e) => setRegisterForm({ ...registerForm, last_name: e.target.value })}
                      required
                      className="glass-input"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      placeholder="user@example.com"
                      value={registerForm.email}
                      onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
                      required
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone *</label>
                    <input
                      type="tel"
                      placeholder="+231 XXX XXX XXX"
                      value={registerForm.phone}
                      onChange={(e) => setRegisterForm({ ...registerForm, phone: e.target.value })}
                      required
                      className="glass-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    placeholder="Minimum 8 characters"
                    value={registerForm.password}
                    onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
                    required
                    className="glass-input"
                  />
                </div>
              </div>

              {/* SECTION 2: Personal Details */}
              <div className="form-section">
                <h3><FiCalendar /> Personal Details</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      value={registerForm.date_of_birth}
                      onChange={(e) => setRegisterForm({ ...registerForm, date_of_birth: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Place of Birth</label>
                    <input
                      type="text"
                      placeholder="City, Country"
                      value={registerForm.place_of_birth}
                      onChange={(e) => setRegisterForm({ ...registerForm, place_of_birth: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Nationality</label>
                    <input
                      type="text"
                      placeholder="e.g., Liberian"
                      value={registerForm.nationality}
                      onChange={(e) => setRegisterForm({ ...registerForm, nationality: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Sex</label>
                    <select
                      value={registerForm.sex}
                      onChange={(e) => setRegisterForm({ ...registerForm, sex: e.target.value })}
                      className="glass-input"
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Marital Status</label>
                    <select
                      value={registerForm.marital_status}
                      onChange={(e) => setRegisterForm({ ...registerForm, marital_status: e.target.value })}
                      className="glass-input"
                    >
                      <option value="">Select</option>
                      <option value="Single">Single</option>
                      <option value="Married">Married</option>
                      <option value="Divorced">Divorced</option>
                      <option value="Widowed">Widowed</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Employment Status</label>
                    <select
                      value={registerForm.employment_status}
                      onChange={(e) => setRegisterForm({ ...registerForm, employment_status: e.target.value })}
                      className="glass-input"
                    >
                      <option value="">Select</option>
                      <option value="Employed">Employed</option>
                      <option value="Self Employed">Self Employed</option>
                      <option value="Unemployed">Unemployed</option>
                      <option value="Student">Student</option>
                      <option value="Retired">Retired</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Number of Children</label>
                  <input
                    type="number"
                    min="0"
                    value={registerForm.number_of_children}
                    onChange={(e) => setRegisterForm({ ...registerForm, number_of_children: parseInt(e.target.value) || 0 })}
                    className="glass-input"
                  />
                </div>
              </div>

              {/* SECTION 3: Address Information */}
              <div className="form-section">
                <h3><FiMapPin /> Address Information</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>County</label>
                    <select
                      value={selectedCounty}
                      onChange={(e) => handleCountyChange(e.target.value)}
                      className="glass-input"
                    >
                      <option value="">Select County</option>
                      {LIBERIA_COUNTIES.map(county => (
                        <option key={county} value={county}>{county}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Postal Address</label>
                    <select
                      value={registerForm.postal_address}
                      onChange={(e) => setRegisterForm({ ...registerForm, postal_address: e.target.value })}
                      className="glass-input"
                      disabled={!selectedCounty}
                    >
                      <option value="">Select Postal Address</option>
                      {availablePostalCodes.map(pc => (
                        <option key={pc.code} value={`${pc.code} - ${pc.area}`}>
                          {pc.code} - {pc.area}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Street Address</label>
                  <input
                    type="text"
                    placeholder="Enter street address"
                    value={registerForm.address}
                    onChange={(e) => setRegisterForm({ ...registerForm, address: e.target.value })}
                    className="glass-input"
                  />
                </div>
              </div>

              {/* SECTION 4: Document Numbers */}
              <div className="form-section">
                <h3><FiFileText /> Document Numbers</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Passport Number</label>
                    <input
                      type="text"
                      placeholder="Enter passport number"
                      value={registerForm.passport_number}
                      onChange={(e) => setRegisterForm({ ...registerForm, passport_number: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Birth Certificate Number</label>
                    <input
                      type="text"
                      placeholder="Enter birth certificate number"
                      value={registerForm.birth_certificate}
                      onChange={(e) => setRegisterForm({ ...registerForm, birth_certificate: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Driver's License Number</label>
                  <input
                    type="text"
                    placeholder="Enter driver's license number"
                    value={registerForm.driver_license}
                    onChange={(e) => setRegisterForm({ ...registerForm, driver_license: e.target.value })}
                    className="glass-input"
                  />
                </div>
              </div>

              {/* SECTION 5: Social / Username */}
              <div className="form-section">
                <h3><FiGlobe /> Social & Display</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="Choose a username"
                      value={registerForm.username}
                      onChange={(e) => setRegisterForm({ ...registerForm, username: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Display Name</label>
                    <input
                      type="text"
                      placeholder="Display name"
                      value={registerForm.display_name}
                      onChange={(e) => setRegisterForm({ ...registerForm, display_name: e.target.value })}
                      className="glass-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Bio</label>
                  <textarea
                    placeholder="Short bio..."
                    value={registerForm.bio}
                    onChange={(e) => setRegisterForm({ ...registerForm, bio: e.target.value })}
                    className="glass-textarea"
                    rows={3}
                  />
                </div>
              </div>

              {registerError && (
                <div className="error-message"><FiAlertCircle /> {registerError}</div>
              )}

              <div className="register-modal-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowRegistrationModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="register-submit-btn" disabled={registerLoading}>
                  {registerLoading ? <FiLoader className="spinning" /> : <FiCheck />}
                  Register {registrationType === 'user' ? 'User' : 'Merchant'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default KYCVerification;
